import { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useUser } from "../../user_context";
import './css/emp_layout.css';

const fontLink = document.createElement("link");
fontLink.rel = "stylesheet";
fontLink.href = "https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;1,400&family=DM+Sans:wght@300;400;500&display=swap";
if (!document.querySelector("link[href*='Cormorant']")) document.head.appendChild(fontLink);

export default function EmpLayout({ children, title, titleEm, topbarRight }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const { userData, loading } = useUser();

  const active = (path) => location.pathname === path;

  // 1. Sidebar Nav Items: Added explicit search index menu row
  const NAV_ITEMS = [
    { path: "/employer/dashboard", icon: "◈", label: "Dashboard" },
    { path: "/employer/candidate-search", icon: "🔍", label: "Find Talent" },
    { path: "/employer/post-job", icon: "+", label: "Post a Job" },
    { path: "/employer/listings", icon: "✦", label: "My Listings", badge: userData?.listingsCount > 0 ? userData.listingsCount : null },
    { path: "/employer/profile", icon: "◯", label: "Business Profile", id: "profile" },
  ];

  // 2. Mobile Bottom Bar Nav Items: Integrated search action hub
  const BOTTOM_NAV = [
    { path: "/employer/dashboard", icon: "◈", label: "Home" },
    { path: "/employer/candidate-search", icon: "🔍", label: "Search" },
    { path: "/employer/post-job", icon: "+", label: "Post a Job" },
    { path: "/employer/listings", icon: "✦", label: "Listings" },
  ];

  useEffect(() => {
    if (!loading && !userData) {
      navigate("/signin", { replace: true });
    }
    const token = localStorage.getItem("token");
    if (!token && userData) {
      window.location.href = "/signin";
    }
  }, [userData, loading, navigate]);

  if (loading) {
    return (
      <div className="layout-loading-screen">
        <div className="spinner">Loading your profile...</div>
      </div>
    );
  }

  if (!userData) return null;

  const displayName = userData?.displayName || "Employer";
  const initials = userData?.initials || "--";

  return (
    <div className="emp-root">
      <div className={`emp-overlay${open ? " open" : ""}`} onClick={() => setOpen(false)} />

      {/* Sidebar Panel Configuration */}
      <aside className={`emp-sidebar${open ? " open" : ""}`}>
        <Link to="/" className="emp-logo">Rembo<span>List</span></Link>

        <div className="emp-nav-label">Main</div>
        {NAV_ITEMS.map(n => (
          <Link key={n.path} to={n.path} className={`emp-nav-item${active(n.path) ? " active" : ""}`} onClick={() => setOpen(false)}>
            <span className="emp-nav-icon" style={{ fontSize: n.icon === "🔍" ? "0.85rem" : "inherit" }}>{n.icon}</span>
            {n.label}
            {n.badge && <span className="emp-nav-badge">{n.badge}</span>}
          </Link>
        ))}

        <div className="emp-sidebar-footer">
          <div className="emp-user-chip">
            <div className="emp-avatar">{loading ? ".." : initials}</div>
            <div>
              <div className="emp-user-name">{loading ? "Loading..." : displayName}</div>
              <div className="emp-user-role">Employer account</div>
            </div>
          </div>
          <button className="emp-signout" onClick={() => {
            localStorage.clear();
            navigate("/signin");
          }}>↩ Sign out</button>
        </div>
      </aside>

      {/* Main Top Header Controls layout */}
      <header className="emp-topbar">
        <div className="emp-topbar-left">
          <button className="emp-hamburger" onClick={() => setOpen(true)} aria-label="Menu">☰</button>
          <div className="emp-topbar-title">{title}{titleEm && <> — <em>{titleEm}</em></>}</div>
        </div>
        
        <div className="emp-topbar-right">
          {topbarRight}
          
          {/* 3. Topbar Search Action Button Trigger */}
          <button 
            type="button"
            className={`emp-notif-btn ${active("/employer/candidate-search") ? "active-search" : ""}`}
            onClick={() => navigate("/employer/candidate-search")}
            title="Search Candidate Directory"
            style={{ fontSize: "1rem", marginRight: "0.25rem" }}
          >
            🔍
          </button>

          <Link to="/employer/post-job" className="emp-post-btn">+ Post a Job</Link>
          
          {/* <button className="emp-notif-btn">
            🔔
            {userData?.notifications > 0 && (
              <span className="emp-notif-dot">{userData.notifications}</span>
            )}
          </button> */}
          <div className="emp-avatar">{initials}</div>
        </div>
      </header>

      {/* Main App Content View Frame */}
      <main className="emp-main">{children}</main>

      {/* Footer Mobile Drawer Systems */}
      <nav className="emp-bottom-nav">
        <div className="emp-bottom-nav-inner">
          {BOTTOM_NAV.map(n => (
            <Link key={n.path} to={n.path} className={`emp-bn-item${active(n.path) ? " active" : ""}`}>
              <span className="emp-bn-icon">{n.icon}</span>
              <span className="emp-bn-label">{n.label}</span>
            </Link>
          ))}
        </div>
      </nav>
    </div>
  );
}